import { render } from "./ProviderExternMailingConf.vue?vue&type=template&id=73000ab2"
import script from "./ProviderExternMailingConf.vue?vue&type=script&lang=js"
export * from "./ProviderExternMailingConf.vue?vue&type=script&lang=js"

import "./ProviderExternMailingConf.vue?vue&type=style&index=0&id=73000ab2&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__